import {Configuration} from './generated';

const config = new Configuration()

const baseURL = import.meta.env.VITE_API_URL;

export const ApiConfig = () => {
    return
}

function getApiConfig() {
    config.basePath = baseURL
    return config;
}

ApiConfig.config = getApiConfig;